// @ts-strict-ignore
import { WidgetFrame } from "components/layout/WidgetFrame";
import { WidgetWithQueryParameters } from "components/layout/WidgetFrame/widget.types";
import {
    KPIDataSourceChartData,
    KPI,
    Regions,
    getThresholdsFromRegions,
    toKPIChartDataPoints,
    getActiveRegion,
} from "components/ui/KPI";
import { useDataSource } from "hooks/useDataSource";

type Props = WidgetWithQueryParameters<"dateFrom" | "dateTo">;

const RepairsPerAstronautKPIWidget = (props: Props) => {
    const { queryParameters } = props;

    const dataSourceParameters = { ...queryParameters, KPI: 5 };

    const chartDataSource = useDataSource<KPIDataSourceChartData[]>(
        "Dashboard_ReportsPerDevice_Chart",
        dataSourceParameters
    );

    const { data, lastDataPoint } = toKPIChartDataPoints(chartDataSource?.data ?? []);

    const regions = [
        { type: "region", color: "red" },
        { type: "threshold", value: 12, regionIfEqual: "lower" },
        { type: "region", color: "pink" },
        { type: "threshold", value: 10, regionIfEqual: "lower" },
        { type: "region", color: "orange" },
        { type: "threshold", value: 8, regionIfEqual: "lower" },
        { type: "region", color: "green" },
        { type: "threshold", value: 5, regionIfEqual: "upper" },
        { type: "region", color: "red" },
    ] satisfies Regions;
    const thresholds = getThresholdsFromRegions({ regions, lastDataPoint });
    const activeRegion = getActiveRegion({ regions, lastDataPoint });
    const color = activeRegion?.color;

    return (
        <>
            <WidgetFrame.Title title={"Repairs per Astronaut"} icon={"lely-icon-astronaut"} size={"sm"}>
                <WidgetFrame.Title.Information lastImportType={"middleware"} pageId={335577267}>
                    Result for each completed month = Number of Repairs (nREP) / Number of active Astronauts (nA). Click
                    on the (i) for more details.
                </WidgetFrame.Title.Information>
            </WidgetFrame.Title>
            <WidgetFrame.KPI dependencies={[chartDataSource]}>
                <KPI.LastValue title="Last Selected Full Month" value={lastDataPoint?.label} color={color} />
                <KPI.Chart data={data} color={color} thresholds={thresholds} />
            </WidgetFrame.KPI>
        </>
    );
};

export { RepairsPerAstronautKPIWidget };
